export const accountViews = {
  botConfig: {
    breadcrumb: {
      listings: "Inserate",
      current: "KI-Agent",
    },
    loading: "Konfiguration wird geladen...",
    retry: "Erneut versuchen",
    loadError: "Fehler beim Laden der Konfiguration.",
    units: "{count} Einheit | {count} Einheiten",
    faqsLabel: "FAQs",
    unitFallback: "Einheit",
    active: "Aktiv",
    inactive: "Inaktiv",
    botWhatsapp: "WhatsApp-Bot",
    otaIa: "OTA-KI",
    saving: "Wird gespeichert...",
    cancel: "Abbrechen",
    assistant: {
      title: "WhatsApp-Assistent",
      desc: "Aktivieren Sie den automatischen Bot, um Ihren Gästen auf WhatsApp zu antworten.",
    },
    ota: {
      title: "OTA-KI",
      desc: "Beantworten Sie Nachrichten von Booking.com, Airbnb und anderen OTAs automatisch.",
      warn: "Aktivieren Sie zuerst den WhatsApp-Assistenten",
    },
    botName: {
      title: "Name des Assistenten",
      desc: "Der Name, mit dem sich der Bot Ihren Gästen vorstellt.",
      empty: "Kein Name vergeben",
      edit: "Bearbeiten",
      placeholder: "Z. B. María, Sofía, Virtueller Assistent...",
      save: "Speichern",
    },
    faqs: {
      title: "Häufige Fragen",
      desc: "Diese FAQs gelten für <strong>alle Einheiten</strong> dieses Inserats. Der Bot nutzt sie, um Ihren Gästen zu antworten.",
      add: "Neue FAQ",
      emptyText: "Sie haben noch keine häufigen Fragen eingerichtet.",
      addFirst: "+ Erste FAQ hinzufügen",
      answerEmpty: "Keine Antwort",
      editTitle: "Bearbeiten",
      deleteTitle: "Löschen",
      questionLabel: "Frage",
      answerLabel: "Antwort",
      questionPlaceholder: "Frage eingeben...",
      answerPlaceholder: "Antwort eingeben, die der Gast sieht...",
      saveChanges: "Änderungen speichern",
    },
    addModal: {
      title: "Neue häufige Frage",
      questionLabel: "Frage",
      questionPlaceholder: "Z. B. Ab wann ist der Check-in möglich?",
      answerLabel: "Antwort",
      answerPlaceholder: "Z. B. Der Check-in ist ab 15:00 Uhr möglich. Wenn Sie früher ankommen, können Sie Ihr Gepäck abstellen...",
      submit: "FAQ hinzufügen",
    },
    deleteModal: {
      title: "Frage löschen",
      confirm: "Möchten Sie diese FAQ wirklich löschen?",
      deleting: "Wird gelöscht...",
      submit: "Ja, löschen",
    },
    types: {
      apartment: "Apartment",
      house: "Haus",
      villa: "Villa",
      hotel: "Hotel",
      room: "Zimmer",
      studio: "Studio",
      default: "Unterkunft",
    },
    toast: {
      botOn: "Bot aktiviert",
      botOff: "Bot deaktiviert",
      botError: "Fehler beim Ändern des Bot-Status",
      otaOn: "OTA-KI aktiviert",
      otaOff: "OTA-KI deaktiviert",
      otaError: "Fehler beim Ändern des Status der OTA-KI",
      nameUpdated: "Name des Assistenten aktualisiert",
      nameError: "Fehler beim Speichern des Namens",
      faqAdded: "FAQ erfolgreich hinzugefügt",
      faqAddError: "Fehler beim Speichern der FAQ",
      faqUpdated: "FAQ aktualisiert",
      faqUpdateError: "Fehler beim Aktualisieren der FAQ",
      faqDeleted: "FAQ gelöscht",
      faqDeleteError: "Fehler beim Löschen der FAQ",
    },
  },

  listingIndex: {
    title: "Inserate",
    subtitle: "Verwalten Sie die zentrale Konfiguration jedes Ihrer Inserate.",
    countFiltered: "{shown} von {total} Inseraten",
    count: "{count} Inserat | {count} Inserate",
    searchPlaceholder: "Nach Name, ID oder Typ suchen…",
    clear: "Leeren",
    loadErrorTitle: "Die Unterkünfte konnten nicht geladen werden",
    retry: "Erneut versuchen",
    emptyTitle: "Keine Inserate",
    emptyText: "Sie haben noch keine Inserate angelegt.",
    noResultsTitle: 'Keine Ergebnisse für „{query}“',
    noResultsText: "Versuchen Sie einen anderen Namen, eine andere ID oder einen anderen Inseratstyp.",
    clearSearch: "Suche leeren",
    dragSearchHint: "Suche leeren, um neu zu sortieren",
    dragHint: "Zum Sortieren ziehen",
    units: "{count} Einheit | {count} Einheiten",
    botActiveTitle: "GPT-Bot aktiv",
    channelTitle: "Mit Channex verbunden",
    icalTitle: "iCal-Synchronisierung",
    editTitle: "Namen bearbeiten",
    modal: {
      title: "Namen des Inserats bearbeiten",
      nameLabel: "Name des Inserats",
      namePlaceholder: "Z. B. Costa Sol Apartments",
      orderLabel: "Reihenfolge des Inserats",
      info: "Ein <strong>Inserat</strong> fasst alle Unterkünfte zusammen, die dieselbe Konfiguration, Willkommensnachrichten und Richtlinien teilen. Der Name, den Sie hier festlegen, kennzeichnet die Gruppe im Panel und in den verbundenen Vertriebskanälen.",
      cancel: "Abbrechen",
      save: "Änderungen speichern",
    },
    types: {
      apartment: "Apartment",
      house: "Haus",
      villa: "Villa",
      hotel: "Hotel",
      room: "Zimmer",
      studio: "Studio",
      default: "Unterkunft",
    },
    toast: {
      connectionError: "Verbindungsfehler.",
      reorderSuccess: "Reihenfolge erfolgreich aktualisiert.",
      reorderError: "Die Reihenfolge der Inserate konnte nicht aktualisiert werden.",
      saveSuccess: "Inserat erfolgreich aktualisiert.",
      saveError: "Fehler beim Speichern des Inserats.",
    },
  },

  unitDetail: {
    back: "Zurück zum Inserat",
    eyebrow: "Einheit",
    save: "Speichern",
    cancel: "Abbrechen",
    editNameTitle: "Namen der Einheit bearbeiten",
    nameFallback: "Einheit",
    types: {
      apartment: "Apartment",
      house: "Haus",
      villa: "Villa",
      hotel: "Hotel",
      camping: "Camping",
      room: "Zimmer",
      studio: "Studio",
      default: "Unterkunft",
    },
    deleteLink: "Einheit löschen...",
    dangerNoteBefore: "Entfernt die Einheit aus dem Inserat",
    dangerNoteAfter: "und aus WACheckin. Diese Aktion kann nicht rückgängig gemacht werden.",
    cards: {
      description: { title: "Beschreibung", sub: "Details der Einheit" },
      capacity: { title: "Kapazität", sub: "Gäste und Betten" },
      services: { title: "Ausstattung und Annehmlichkeiten", sub: "Was es bietet, mit Fotos" },
      rules: { title: "Zeiten", sub: "Check-in- und Check-out-Zeiten" },
      arrival: { title: "Anreisehinweise", sub: "Anfahrt und Zutritt · mit Versandzeitpunkt" },
      smartlocks: { title: "Schlösser und Zutritt", sub: "Wie der Gast hineinkommt" },
      checkout: { title: "Check-out-Nachricht", sub: "Erinnerung an den Check-out · Vorlage" },
      scheduled: { title: "Geplante Nachrichten", sub: "Nachrichten nur für diese Einheit" },
      unitFaq: { title: "Fragen und Antworten", sub: "Für den Agenten, speziell zu dieser Einheit", badge: "KI" },
      welcome: { title: "Willkommensnachricht", sub: "Nachricht speziell für diese Einheit" },
      stockExtra: {
        title: "Zusätzlicher Bestand",
        subOff: "Aus · übernimmt Buchungen einer anderen Einheit",
        subOn: "Puffer für {name}",
        subOnGeneric: "Puffer für eine andere Einheit",
        badge: "An",
      },
    },
    sections: {
      aiOnlyLabel: "Häufige Fragen zur Einheit",
      aiOnlyDesc: "Der Agent bevorzugt sie, wenn er einem Gast hilft, der in dieser Einheit wohnt.",
      specificLabel: "Einstellungen speziell für diese Einheit",
      detailLabel: "Diese Einheit beschreiben",
      detailDesc: "Zusätzliche Informationen, die wir für Direktbuchungen und für den KI-Agenten nutzen.",
    },
    stockExtra: {
      title: "Zusätzlicher Bestand",
      intro: "Auf Booking oder Airbnb haben Sie vielleicht ein einziges Inserat mit Platz für mehrere Apartments: Da nur eines zugeordnet werden kann, sendet der Kanal alle diese Buchungen an dieselbe Einheit und sie häufen sich als Überbuchung.",
      how: "Wenn Sie diese Einheit als zusätzlichen Bestand einer anderen markieren, werden Buchungen, die mit der Haupteinheit kollidieren, hier gespeichert, und der Kanal wird informiert, damit sie dort ebenfalls in dieser Einheit erscheinen.",
      purpose: "Es ist ein Werkzeug für den Übergang: Aktivieren Sie es, um zu übernehmen, was Sie auf der OTA bereits verkauft hatten, und schalten Sie es aus, sobald jedes Apartment sein eigenes Inserat hat.",
      loading: "Wird geladen...",
      activeLabel: "Puffer für {name}",
      activeHint: "Buchungen aus dem Kanal, die mit {name} kollidieren, werden in dieser Einheit gespeichert.",
      activeBadge: "An",
      otherUnit: "eine andere Einheit",
      warnTitle: "Aktivieren Sie es nicht, wenn jedes Apartment auf der OTA bereits ein eigenes zugeordnetes Inserat hat:",
      warnText: "Dort sendet der Kanal jede Buchung bereits an die eigene Einheit, und mit aktiviertem zusätzlichen Bestand würde eine Buchung in einem Apartment landen, das nicht das verkaufte ist.",
      principalOf: "Andere Einheiten stützen sich bereits auf diese:",
      chooseLabel: "Haupteinheit",
      chooseDesc: "Wählen Sie die Einheit, deren Buchungen in „{unit}“ gespeichert werden, wenn sie miteinander kollidieren.",
      noCandidates: "In diesem Inserat gibt es keine weitere Einheit, die abgesichert werden kann.",
      activate: "Zusätzlichen Bestand aktivieren",
      change: "Haupteinheit ändern",
      saving: "Wird gespeichert...",
      removeBtn: "Zusätzlichen Bestand entfernen",
      removeNote: "Bereits hier gespeicherte Buchungen werden nicht verschoben: Sie bleiben in dieser Einheit.",
      errorCarga: "Die Einstellungen für den zusätzlichen Bestand konnten nicht geladen werden. Wenn Sie gerade aktualisiert haben, laden Sie die Seite neu.",
      reintentar: "Erneut versuchen",
      toastLoadError: "Der zusätzliche Bestand konnte nicht geladen werden.",
      toastSaveError: "Der zusätzliche Bestand konnte nicht gespeichert werden.",
    },
    toast: {
      nameEmpty: "Der Name darf nicht leer sein",
      nameUpdated: "Name aktualisiert",
      nameError: "Der Name konnte nicht aktualisiert werden",
    },
  },

  miCuenta: {},
};
